
interface StatsParameter {
    [key: string] : string
}

const Stats = {
    google : (eventName: string, params?: StatsParameter) => {
        // console.info(eventName, params);
        if(typeof gtag === 'function'){
            gtag('event', eventName, params);
        }
    }
}

export default Stats ;